import HeaderLinkDropdown from '@/components/elements/HeaderLink/dropdown';
import { BurgerMenuIcon } from '@/components/elements/icons/burger-menu-icon';
import Logo from '@/components/elements/icons/logo';
import {
  Button,
  Flex,
  IconButton,
  useBreakpointValue,
  useDisclosure,
  Link as Clink,
} from '@chakra-ui/react';
import { useRouter } from 'next/dist/client/router';
import React from 'react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import MenuOverlay from '../MenuOverlay';

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const shouldOpenOverlayMenu = useBreakpointValue([true, true, true, false]);
  const { push } = useRouter();
  const { t } = useTranslation(`common`);
  return (
    <Flex
      className="boxed-container"
      as="header"
      justify="space-between"
      align="center"
    >
      <Link href="/" passHref>
        <Clink aria-label="voltran" me={[null, null, null, 16]}>
          <Logo h="35px" w="auto" />
        </Clink>
      </Link>
      <IconButton
        aria-label="open menu"
        icon={<BurgerMenuIcon boxSize="27px" />}
        display={[null, null, null, `none`]}
        variant="ghost"
        size="lg"
        onClick={onOpen}
      />
      <MenuOverlay
        isOpen={!!shouldOpenOverlayMenu && isOpen}
        onClose={onClose}
        elements={[
          {
            title: t(`navigation.what_is_voltran.title`),
            link: `/`,
            subMenu: [
              {
                link: `/features`,
                title: t(`navigation.what_is_voltran.features`),
              },
              {
                link: `/features#how-it-works`,
                title: t(`navigation.what_is_voltran.how_it_works`),
                element: `cta`,
              },
              { link: `/faq`, title: t(`navigation.what_is_voltran.faq`) },
            ],
          },
          {
            title: t(`navigation.about_us.title`),
            link: `/about-us`,
            subMenu: [
              {
                link: `/about-us#our-aim`,
                title: t(`navigation.about_us.our_aim`),
              },
              { link: `/about-us#team`, title: t(`navigation.about_us.team`) },
            ],
          },
        ]}
      />
      <Flex
        display={[`none`, null, null, `flex`]}
        justify="center"
        align="baseline"
        h="16"
      >
        <HeaderLinkDropdown
          title={t(`navigation.what_is_voltran.title`)}
          link="/"
          subMenu={[
            {
              link: `/features`,
              title: t(`navigation.what_is_voltran.features`),
            },
            {
              link: `/features#how-it-works`,
              title: t(`navigation.what_is_voltran.how_it_works`),
              element: `cta`,
            },
            { link: `/faq`, title: t(`navigation.what_is_voltran.faq`) },
          ]}
        />
        <HeaderLinkDropdown
          title={t(`navigation.about_us.title`)}
          link="/about-us"
          subMenu={[
            {
              link: `/about-us#our-aim`,
              title: t(`navigation.about_us.our_aim`),
            },
            { link: `/about-us#team`, title: t(`navigation.about_us.team`) },
          ]}
        />
        <Button
          onClick={() => push(`/download`)}
          ms="8"
          size="lg"
          variant="solid-brand-header"
          colorScheme="blue"
        >
          {t(`navigation.download`)}
        </Button>
      </Flex>
    </Flex>
  );
};

export default Header;
